// import './index.css'
import './index.css'
const Video =  ()=>{
    return(
        <div className='main-div'>
        <div className='nav'>
            <div className='navbar'>
                <p>Home</p>
                <p>Videos</p>
                <p>Blogs</p>
                <p>Podcast</p>
                <p>Portfolio</p>

            
        </div>
        </div>
        <div className='amazon'>
            <p>Learn more about how Amazon Works</p>
        </div>
       
        <div className='video-section'>
        <div><iframe src="https://www.loom.com/embed/05c92e2356b241a190331102702e717f?sid=3e80a60a-83ec-4a16-9d30-42776125a85d" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen className='video-Aline'></iframe></div>

        <div><iframe src="https://www.loom.com/embed/8d206f8112944664b7d3ffa4882fb1b5?sid=f4519c72-b2f7-41b0-95ed-bcd9a6a13bc1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen className='video-kur'></iframe></div>
        </div>
        <div className='video-section2'>
        <div><iframe src="https://www.loom.com/embed/df35a47c7beb4b8884697ffc4412f3c0?sid=6e68dda4-cd02-4429-be9a-30a28b67b3bc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen className='video-wato'></iframe></div>

        <div><iframe src="https://www.loom.com/embed/891c0693fd4f4f8e94c3ea1e401cc8bb?sid=c3a2807b-76ce-4549-97b2-b2a12e37d4a5" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen className='video-linet'></iframe></div>
        </div>
        <div>
        <div><iframe src="https://www.loom.com/embed/abb01c10963244498519680dbe8f9a4c?sid=ec97ea9e-8ff5-4c90-8d72-2c2ef7dd300e" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen  className='video-daisy'></iframe></div>
        </div>
        
        
        
    
        
        </div>
        
    )
}
export default Video;